// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1xwzU","header":"ReportDetails_header__1j2mZ","title":"ReportDetails_title__285v2","left":"ReportDetails_left__13wrz"};